module.exports = __webpack_public_path__ + "static/media/next.445c4382.png";